module.exports = __webpack_public_path__ + "static/TheMetSans-RegularItalic-8553ba91381b355eee20207c90daf69a.woff2";